import React, { useCallback } from 'react';
import { Box, Button, createStyles, Typography, withStyles } from '@material-ui/core';
import { I18n } from 'src/translations/i18n';
import DoneIcon from '@material-ui/icons/Done';
const styles = (theme) => createStyles({
    scrollContainer: {
        height: '100%',
        overflow: 'auto',
        ...theme.themedClasses.scrollbar
    },
    listContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingRight: theme.spacing(1)
    },
    jobButtonContainer: {
        width: '100%'
    },
    text: {
        color: theme.palette.text.color
    },
    selectionIcon: {
        position: 'absolute',
        left: 8,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        transform: 'scale(0.8)'
    }
});
function getJobButtonStyle(job) {
    return {
        backgroundColor: job.JobColorStart,
        color: job.FontColor,
        paddingLeft: 30,
        paddingRight: 30
    };
}
function AvailableJobsList({ classes, selectedJob, availableJobs, onJobSelect, disableSelect }) {
    const getJobSelectHandleFn = useCallback((job) => () => onJobSelect(job), [onJobSelect]);
    return (React.createElement("div", { className: classes.scrollContainer },
        React.createElement("div", { className: classes.listContainer }, !availableJobs?.length
            ? (React.createElement(Box, { display: "flex", justifyContent: "center", alignItems: "center" },
                React.createElement(Typography, { variant: "body2", className: classes.text }, I18n.t('NoDataAvailable'))))
            : availableJobs.map((job) => (React.createElement(Button, { key: job.JobId, variant: "contained", size: "large", fullWidth: true, style: getJobButtonStyle(job), disabled: disableSelect, onClick: getJobSelectHandleFn(job) },
                job.JobId === selectedJob?.JobId && (React.createElement("span", { className: classes.selectionIcon },
                    React.createElement(DoneIcon, null))),
                React.createElement("span", null, job.JobName)))))));
}
export default withStyles(styles)(AvailableJobsList);
